import {
    request
} from "./request";

export function getBasicStatisticFromKnowledge() {
    return request({
        url: '/ascancer/api/statistic/knowledge/basic',
    })
}

export function getStatisticNumberFromKnowledge() {
    return request({
        url: '/ascancer/api/statistic/knowledge',
    })
}

export function getStatisticNumberFromDatasets() {
    return request({
        url: '/ascancer/api/statistic/datasets',
    })
}